import { useContext } from "react";

import { useTranslation } from "react-i18next";

import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import ActionToolbarButtonWrapper from "components/DesignComponents/Button/ActionToolbarButtonWrapper";
import TableContext from "context/table/tableContext";
import { useMediaQueries, usePermissions } from "shared";

import UploadFile from "../dialogs/Files/UploadFile";
import { FILE_ACTIONS } from "../types";
import ContentFrame from "./components/ContentFrame";
import { useDialog } from "./hooks";

const FilesBar = () => {
    const { isInitialLoading } = useContext(TableContext);

    const { t } = useTranslation();
    const { toSm } = useMediaQueries();
    const { isOpenDialog, openDialog, closeDialog } = useDialog();
    const { isCreateFileNotAllowed, PERMISSIONS } = usePermissions();

    return (
        <>
            <ContentFrame>
                <ActionToolbarButtonWrapper
                    permissionName={PERMISSIONS.FileCreate}
                >
                    <Button
                        fullWidth={toSm}
                        hasRectangleLoader={toSm && isInitialLoading}
                        variant={BUTTON_VARIANTS.TextOnly}
                        size={BUTTON_SIZES.Small}
                        color={BUTTON_COLORS.Primary}
                        disabled={isCreateFileNotAllowed}
                        onClick={() => openDialog(FILE_ACTIONS.UploadFiles)}
                    >
                        {t("Button##upload")}
                    </Button>
                </ActionToolbarButtonWrapper>
            </ContentFrame>

            <UploadFile
                isOpen={isOpenDialog[FILE_ACTIONS.UploadFiles]}
                close={closeDialog}
            />
        </>
    );
};

export default FilesBar;
